import api from 'app/api';
import store from 'app/store';

export const getEventById = async (id, callback) => {
  const successCallback = ({ data }) => {
    const { payload, ...rest } = data || {};
    store.dispatch({
      type: 'ADMIN_PRIMARY_EVENT_EDIT:EVENT_DATA:SET',
      data: {
        eventDetails: { ...payload, id },
        eventMetaDetails: { ...rest },
        smpId: rest?.smp_id || payload?.id,
        mongoId: payload?._id || id,
      }
    });

    if (callback) callback(data);
  };

  await api.get(
    `/events/${id}`,
    {
      id: 'save-event',
      success: {
        callback: successCallback,
      },
      failure: {
        showNotifier: true,
      },
    },
  );
};

export const updateEvent = async (id, payload, callback) => {
  const successCallback = ({ data }) => {
    if (data?.payload) {
      const { payload, ...rest } = data || {};
      store.dispatch({
        type: 'ADMIN_PRIMARY_EVENT_EDIT:EVENT_DATA:SET',
        data: {
          eventDetails: { ...payload, id },
          eventMetaDetails: { ...rest },
          smpId: rest?.smp_id || payload?.id,
          mongoId: payload?._id || id,
        }
      });
    } else {
      store.dispatch({
        type: 'ADMIN_PRIMARY_EVENT_EDIT:EVENT_DATA:SET',
        data: {
          eventDetails: { ...data?.data, id },
          smpId: data?.data?.id,
          mongoId: data?.payload?._id || id,
        }
      });
    }


    if (callback) callback(data);
  };

  await api.put(
    `/events/primary/${id}`,
    payload,
    {
      id: 'save-event',
      success: {
        callback: successCallback,
      },
    },
  );
};

export const getEventDashboard = async (id, callback) => {
  const successCallback = ({ data }) => {
    store.dispatch({ type: 'ADMIN_PRIMARY_EVENT_EDIT:DASHBOARD_DATA:SET', data });

    if (callback) callback(data);
  };

  await api.get(
    `/dashboard/${id}`,
    {
      id: 'get-event-dashboard',
      success: {
        callback: successCallback,
      },
      failure: {
        showNotifier: true,
      },
      params: {
        filter: 'yearly',
      },
    },
  );
};

export const getEventAttendees = async (id, params, callback) => {
  const successCallback = ({ data }) => {
    store.dispatch({
      type: 'ADMIN_PRIMARY_EVENT_EDIT:ATTENDEES_LIST:SET',
      data: {
        attendeesList: (data?.data || []).map((attendeeDetails) => attendeeDetails?.details || []),
        pagination: data?.pagination,
      },
    });


    if (callback) callback(data);
  };

  await api.get(
    `/events/attendees/${id}`,
    {
      id: 'get-event-attendees',
      success: {
        callback: successCallback,
      },
      failure: {
        showNotifier: true,
      },
      params,
    },
  );
};

export const approveEvent = async (id, payload, callback, failureCb) => {
  const successCallback = ({ data, ...rest }) => {
    console.log(data);
    store.dispatch({
      type: 'ADMIN_PRIMARY_EVENT_EDIT:EVENT_DATA:SET',
      data: {
        eventDetails: { ...data, id },
        eventMetaDetails: { ...rest },
        smpId: rest?.smp_id,
      }
    });

    if (callback) callback(data);
  };

  await api.post(
    `/events/${id}/approve`,
    payload,
    {
      id: 'save-event',
      success: {
        callback: successCallback,
      },
      failure: {
        callback: failureCb,
        showNotifier: true,
      }
    },
  );
};

export const deleteEvent = async (id, isDraft, callback) => {
  const successCallback = ({ data }) => {
    if (callback) callback(data);
  };

  await api.delete(
    `/events/primary/${id}`,
    {
      id: 'delete',
      success: {
        callback: successCallback,
      },
      failure: {
        showNotifier: true,
      },
      params: {
        isDraft,
      },
    },
  );
};
